import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

// Claves de la versión anterior, que guardaba usuarios y contraseñas en el navegador.
const LEGACY_KEYS = ['dojo_session', 'dojo_users', 'dojo_events'];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      LEGACY_KEYS.forEach(key => localStorage.removeItem(key));
    } catch {
      // localStorage puede no estar disponible (modo privado)
    }

    api('/auth/me')
      .then(data => setUser(data.user))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await api('/auth/login', { method: 'POST', body: { email, password } });
    setUser(data.user);
  };

  const guestLogin = async () => {
    const data = await api('/auth/guest', { method: 'POST' });
    setUser(data.user);
  };

  const register = async (form) => {
    const data = await api('/auth/register', { method: 'POST', body: form });
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api('/auth/logout', { method: 'POST' });
    } finally {
      setUser(null);
    }
  };

  const isGuest = user?.roles?.includes('invitado');
  const isAdmin = user?.roles?.includes('admin');
  const canManageEvents = isAdmin || user?.roles?.includes('profesor');

  return (
    <AuthContext.Provider value={{ user, loading, login, register, guestLogin, logout, setUser, isAdmin, isGuest, canManageEvents }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
